export function toClosedAtRange(params: {
  closedFrom: string | null
  closedTo: string | null
}): { fromIso: string | null; toIsoExclusive: string | null } {
  const from = parseDateInput(params.closedFrom)
  const to = parseDateInput(params.closedTo)
  const fromIso = from ? new Date(from.getFullYear(), from.getMonth(), from.getDate(), 0, 0, 0, 0).toISOString() : null
  const toIsoExclusive = to
    ? new Date(to.getFullYear(), to.getMonth(), to.getDate() + 1, 0, 0, 0, 0).toISOString()
    : null
  return { fromIso, toIsoExclusive }
}

function parseDateInput(date: string | null): Date | null {
  const s = String(date || '').trim()
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null
  const [y, m, d] = s.split('-').map((x) => Number(x))
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null
  const dt = new Date(y, m - 1, d, 0, 0, 0, 0)
  if (Number.isNaN(dt.getTime())) return null
  return dt
}

